import React, { Component } from 'react';

import {
    Content,
    Label,
    Section,
    TelevisionStyled,
    Text,
    Title,
} from  './styled';
export default class SectionFunctions extends Component {
    render() {
        const { activeSlide, prevSlide, breakpoint, ...props } = this.props;

        const isActive = (activeSlide.link === 'advantage');
        const from = (isActive) ? prevSlide.link : null;
        const to = (!isActive) ? activeSlide.link : null;

        return (
            <Section isActive={isActive} from={from} to={to} {...props}>
                <Content>
                    <Title>Свобода от расписания эфира. Без рекламы.</Title>
                    <Text>
                        Отвлекли от решающего гола? Отмотайте эфир назад.
                        Перематывайте рекламу во время захватывающего боевика.
                        И ставьте его на паузу, если нужно ответить на звонок.
                    </Text>
                </Content>

                <TelevisionStyled breakpoint={breakpoint} mod='sectionFunctions' isPlay={isActive}/>
                <Label>*На странице использован фрагмент из&nbsp;кинофильма «Тоня против всех»</Label>
            </Section>
        );
    }
}
